import { takeLatest } from 'redux-saga/effects';
import { ActionTypes } from '../constants';
import utils from '../utils';
import Api from '../api';
import patternSaga from './patternSaga';

const pinnedBlogsApiUrl = `${utils.config.apiUserUrl}/pinned-blogs`;

const failureNotification = {
  notification: {
    type: 'error',
    notificationType: 'notification',
    staticNotification: true,
    className: 'ant-notification-error'
  }
};

const fetchPinnedBlogsSaga = {
  requestFunction: Api.PinnedBlogs.getPinnedBlogs,
  requestUrl: pinnedBlogsApiUrl,
  onFailure: failureNotification
};

const savePinnedBlogsSaga = {
  requestFunction: Api.PinnedBlogs.savePinnedBlogs,
  requestUrl: pinnedBlogsApiUrl,
  spinner: true,
  onSuccess: {
    notification: {
      staticNotification: true,
      data: { code: '101' }
    }
  },
  onFailure: failureNotification
};

export default function* watchPinnedBlogsSaga() {
  yield takeLatest(ActionTypes.GET_PINNED_BLOGS_REQUEST, patternSaga, fetchPinnedBlogsSaga);
  yield takeLatest(ActionTypes.SAVE_PINNED_BLOGS_REQUEST, patternSaga, savePinnedBlogsSaga);
}
